import { Box, Heading, SimpleGrid } from "@chakra-ui/layout";
import PlanCard from "./components/PlanCard";

const PlanDisplay = ({ title, plans }) => {
  return (
    <Box textAlign="center" my={8}>
      {title && (
        <Heading as="h4" mb={4}>
          {title}
        </Heading>
      )}
      <SimpleGrid columns={1} spacing={2}>
        {plans && plans.map((plan) => <PlanCard {...plan} key={plan.id} />)}
      </SimpleGrid>
    </Box>
  );
};

export default PlanDisplay;
